export default "__VITE_ASSET__DlzMEE_M__"